import {useEffect, useState} from 'react';

import {useTimeout} from '../../../../../libs/shared/core/src/helpers/react/hooks/hookHelpers';

/*
 * Hooks.
 */

/** Suspends a value until the given condition becomes true + the given delay. */
export function useSuspendedUntil<T>(value: T, condition: boolean, delay: number) {
  const [suspendedValue, setSuspendedValue] = useState(value);

  const [setTimeout, clearTimeout] = useTimeout();
  useEffect(() => {
    if (condition) {
      setTimeout(() => {
        setSuspendedValue(value);
      }, delay);
    } else {
      clearTimeout();
    }
  }, [value, condition, delay, setTimeout, clearTimeout]);

  return suspendedValue;
}
